export default __webpack_public_path__ + "static/media/Paytm.94e5e77e.svg";